import React from 'react';
import '../../styles/ProgressionUI/ExerciseList.css';

const ExerciseList = ({ exercises, selectedExercise, onSelectExercise, onHoverExercise, onHoverEnd }) => {
  return (
    <div className="exercise-list-container">
      <h2>Exercises</h2>
      <ul className="exercise-list">
        {exercises.map((exercise, index) => (
          <li 
            key={index} 
            className={`exercise-item ${selectedExercise === exercise ? 'selected' : ''}`}
            onClick={() => onSelectExercise(exercise)}
            onMouseEnter={() => onHoverExercise(exercise)}
            onMouseLeave={onHoverEnd}
          >
            {exercise}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ExerciseList;